import { merge } from 'lodash-es';
import {
  dateOfBirthUI,
  fullNameUI as fullNameWithSuffixUI,
  emailUI as platformEmailUI,
  phoneUI as platformPhoneUI,
  ssnUI as platformSsnUI,
  radioUI,
  selectUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { replaceStrValues } from 'platform/shared/health-apps';
import { genderLabels } from 'platform/static-data/labels';
import content from '../locales/en/content.json';
import { validateSsnIsUnique } from '../utils/validation';

export const dobUI = label =>
  dateOfBirthUI(replaceStrValues(content['form-dob-label'], label));

export const emailUI = label =>
  platformEmailUI(replaceStrValues(content['form-email-label'], label));

export const fullNameUI = ({ label, labelAlt }) =>
  merge(
    {},
    fullNameWithSuffixUI(title => `${label} ${title}`),
    {
      first: {
        'ui:options': {
          hint: replaceStrValues(content['form-name-hint'], labelAlt || label),
        },
      },
    },
  );

export const genderUI = label =>
  radioUI({
    title: replaceStrValues(content['form-birth-sex-label'], label),
    labels: genderLabels,
    hint: replaceStrValues(content['form-birth-sex-hint'], label),
  });

export const phoneUI = label =>
  platformPhoneUI({
    title: replaceStrValues(content['form-phone-label'], label),
    hint: content['form-phone-hint'],
  });

export const ssnUI = ({ label, type }) => {
  const uiToMerge = platformSsnUI(
    replaceStrValues(content[`form-${type}-label`], label),
  );
  return merge({}, uiToMerge, {
    'ui:errorMessages': {
      pattern: content[`validation-${type}-general`],
      required: content[`validation-${type}-general`],
    },
    'ui:validations': [...uiToMerge['ui:validations'], validateSsnIsUnique],
  });
};

export const vetRelationshipUI = label =>
  selectUI({
    title: replaceStrValues(content['form-vet-relationship-label'], label),
  });
